/**
 * Helper unico per il display dei valori di salto (CMJ) nelle viste readiness.
 *
 * Contratto BE: value/rawValue è SEMPRE salvato in cm; il payload readiness
 * porta l'unità di compilazione opzionale `cmjUnit: 'cm' | 'in'`
 * (assente = cm). Storage e calcoli restano in cm — SOLO il display converte.
 *
 * Conversione display: pollici = cm / 2.54, 1 decimale.
 */

import { IN_TO_CM } from '@leopart/calc';

export type JumpUnit = 'cm' | 'in';

// Fattore unico di conversione pollici↔cm (@leopart/calc), non più 2.54 locale.
const CM_PER_INCH = IN_TO_CM;

/**
 * Converte un valore salvato in cm nel numero da mostrare (input/chart label)
 * nell'unità di compilazione. Per 'cm' ritorna il valore invariato,
 * per 'in' converte con 1 decimale.
 */
export function jumpDisplayValue(valueCm: number, unit?: JumpUnit): number {
  if (unit === 'in') return Number((valueCm / CM_PER_INCH).toFixed(1));
  return valueCm;
}

/**
 * Formatta un valore salvato in cm nell'unità di compilazione:
 * "25.0 in" | "63.5 cm" | "-" (valore assente).
 */
export function formatJump(valueCm: number | null | undefined, unit?: JumpUnit): string {
  if (valueCm == null || Number.isNaN(valueCm)) return '-';
  const displayUnit: JumpUnit = unit === 'in' ? 'in' : 'cm';
  return `${jumpDisplayValue(valueCm, displayUnit).toFixed(1)} ${displayUnit}`;
}
